module.exports = __webpack_public_path__ + "static/media/location2.f2b9b547.jpg";